'use client'

import Box from '@mui/material/Box';
import useScrollSpy from '@/src/hooks/useScrollSpy';
import { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { PAPER_BACKGROUND } from "@/src/constant/constant";

const circle = (size: number) => ({
    content: '""',
    position: 'absolute',
    borderRadius: '50%',
    left: `calc(50% - ${size / 2})px`,
    top: `calc(50% - ${size / 2})px`,
    width: size,
    height: size,
});

const ReadingProgress = styled(Box)(({ theme }) => {
    const progressPieChartSize: number = 80;

    return ({
        width: progressPieChartSize,
        height: progressPieChartSize,
        borderRadius: '50%',
        backgroundColor: '#e8e0d8',
        position: 'relative',
        boxShadow: '0 0 10px rgba(0, 0, 0, .25)',
        '&.gt-50': {
            backgroundColor: theme.palette.success.main,
            '.ppc-progress': {
                clip: `rect(0, ${progressPieChartSize / 2}px, ${progressPieChartSize}px, 0)`,
                '.ppc-progress-fill': {
                    clip: `rect(0, ${progressPieChartSize}px, ${progressPieChartSize}px, ${progressPieChartSize / 2}px)`,
                    background: '#e8e0d8',
                }
            }
        },
        '.ppc-progress': {
            ...circle(progressPieChartSize),
            clip: `rect(0, ${progressPieChartSize}px, ${progressPieChartSize}px, ${progressPieChartSize / 2}px)`,
            '.ppc-progress-fill': {
                ...circle(progressPieChartSize),
                clip: `rect(0, ${progressPieChartSize / 2}px, ${progressPieChartSize}px, 0)`,
                background: theme.palette.success.main,
                transform: 'rotate(360deg)'
            }
        },
        '.ppc-percents': {
            ...circle(progressPieChartSize / 1.05),
            backgroundImage: `url(${PAPER_BACKGROUND}) !important`,
            backgroundColor: theme.palette.background.default,
            textAlign: 'center',
            display: 'table',
            boxShadow: 'inset 0 0 15px rgba(darken($cream, 20%), .25)',
            'span': {
                color: theme.palette.success.main
            }
        },
        '.pcc-percents-wrapper': {
            display: 'table-cell',
            verticalAlign: 'middle',
        }
    })
});
const TimeProgress = ({ contentText }: { contentText: string }) => {
    const scrollSpy = useScrollSpy(contentText);

    useEffect(() => {
        const handleScroll = () => {
            scrollSpy.handleScroll();
        };

        handleScroll();

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <ReadingProgress
            display={{ xs: "none", md: "flex" }}
            alignItems={"center"}
            justifyContent={"center"}
            mb={1.5}
            mx={"auto"}
            className={
                `${scrollSpy.progress > 50 ? 'gt-50' : ''}`
            }
        >
            <Box className="ppc-progress">
                <Box
                    className="ppc-progress-fill"
                    sx={{
                        transform: `rotate(${scrollSpy.degree}deg) !important`
                    }}>
                </Box>
            </Box>
            <Box className="ppc-percents">
                <Box className="pcc-percents-wrapper">
                    <Box component="span" whiteSpace={"nowrap"} fontSize={'1.125rem'}>
                        {scrollSpy.remainingTime !== undefined ? `${scrollSpy.remainingTime} min` : ''}
                    </Box>
                </Box>
            </Box>
        </ReadingProgress>
    )
}

export default TimeProgress;